import React, { useState } from 'react'
import PropTypes from 'prop-types'

export const Checkbox = ({ checked, onChange }) => {
  const [isChecked, setIsChecked] = useState(checked)

  const handleChange = () => {
    const checkState = !isChecked
    setIsChecked(checkState)
    onChange(checkState)
  }

  return (
    <div className="status-marker">
      <input
        name="{checked}"
        type="checkbox"
        onChange={handleChange}
        checked={isChecked}
      />
    </div>
  )
}
Checkbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
}
